import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const POINTS = ["Reduces chlorine taste and odour", "Helps protect taps, appliances and hot water units", "Whole-house or under-sink options", "Installed and serviced by a licensed plumber"];

export const Filtration = ({ onQuote }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);
  return (
    <section ref={ref} id="filtration" className="grain relative overflow-hidden bg-[#0B1F42] py-24 text-white lg:py-32" data-testid="filtration-section">
      <div className="absolute -left-40 top-1/3 h-[480px] w-[480px] rounded-full bg-[#1E6FE0]/30 blur-[120px]" />
      <div className="relative mx-auto grid max-w-[1400px] items-center gap-14 px-5 lg:grid-cols-12 lg:px-10">
        <Reveal className="order-2 lg:order-1 lg:col-span-6">
          <Eyebrow light>Water filtration</Eyebrow>
          <h2 className="font-display text-4xl font-extrabold leading-[1] tracking-tight sm:text-6xl">Better water.<br /><span className="text-[#5FB4FF]">A healthier home.</span></h2>
          <p className="mt-6 max-w-lg text-base text-white/80 md:text-lg">Clean, great-tasting water for your whole house — from the kitchen tap to the shower.</p>
          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-center gap-3 text-white/90"><span className="grid h-6 w-6 place-items-center rounded-full bg-[#FF6B00]"><Check className="h-3.5 w-3.5" /></span>{p}</li>
            ))}
          </ul>
          <button onClick={() => onQuote("Water Filtration")} data-testid="filtration-cta-button"
            className="shimmer group mt-10 inline-flex items-center gap-3 rounded-full bg-[#FF6B00] px-8 py-4 font-bold uppercase tracking-[0.08em] transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-[#E05A00]">
            Ask about filtration <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </button>
        </Reveal>
        <Reveal className="order-1 lg:order-2 lg:col-span-6">
          <div className="relative mx-auto aspect-square max-w-lg overflow-hidden rounded-[2rem] rounded-tl-[7rem] ring-1 ring-white/15 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.7)]">
            <motion.img style={{ y }} src="/images/filtration-install.jpg" alt="Stainless steel whole-house water filtration system installed by Plumberoo on a brick wall" className="absolute inset-0 h-[110%] w-full -translate-y-[5%] object-cover object-top" data-testid="filtration-photo" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,transparent_55%,rgba(11,31,66,0.45))]" />
            <span className="absolute bottom-5 left-5 rounded-full bg-white/90 px-3 py-1 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-[#0F2B5B]">Our work</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
